import httpInstance from '../httpInstance';

const getVersionsService = async () => {
  const endpoint = '/back-office/v1/device-version/all';
  const res = await httpInstance.get(endpoint);
  return res;
};

export default getVersionsService;
